export const version = "contracts/5.6.1";
